export default "__VITE_ASSET__qrkgSdja__"